import Repository from './Repository';
import { NutrientClaims } from '@/models/Claims/NutrientClaims';
import { RecipeUserClaim } from '@/models/Claims/RecipeUserClaim';
import {AxiosResponse} from "axios";
import {NutritionLabelCountry} from "@/models/NutritionLabels/NutritionLabelCountry";

const resource = '/claims';

export default {
  getEnabledClaimsForRecipe(recipeId: number, countryId: NutritionLabelCountry): Promise<AxiosResponse<string[]>> {
    return Repository.get<string[]>(
      `${resource}/GetEnabledClaimsDisplayTextForRecipe?recipeId=${recipeId}&countryId=${countryId}`,
      { withCredentials: true }
    );
  },
  getClaimsForRecipe(recipeId: number, countryId: NutritionLabelCountry): Promise<AxiosResponse<NutrientClaims[]>> {
    return Repository.get<NutrientClaims[]>(
      `${resource}/GetClaimsForRecipe?recipeId=${recipeId}&countryId=${countryId}`,
      { withCredentials: true }
    );
  },
  getRecipeUserClaims(recipeId: number, countryId: NutritionLabelCountry): Promise<AxiosResponse<RecipeUserClaim[]>>{
    return Repository.get<RecipeUserClaim[]>(
      `${resource}/GetRecipeUserClaims?recipeId=${recipeId}&countryId=${countryId}`,
      { withCredentials: true }
    );
  },
  saveClaims(recipeId: number, nutrientClaims: NutrientClaims[], userClaims: RecipeUserClaim[]) {
    return Repository.post(
      `${resource}/SaveClaimsForRecipe?recipeId=${recipeId}`,
      {
        nutrientClaims: nutrientClaims,
        userClaims: userClaims
      },
      { withCredentials: true }
    );
  },
  deleteUserClaim(restaurantId: number, claimId: number) {
    return Repository.delete(
      `${resource}/DeleteUserClaim?restaurantId=${restaurantId}&claimId=${claimId}`,
      { withCredentials: true }
    );
  },
  updateUserClaimText(restaurantId: number, recipeUserClaim: RecipeUserClaim) {
    return Repository.put(
      `${resource}/UpdateUserClaimText`,
      {
        restaurantId: restaurantId,
        claimId: recipeUserClaim.userClaim.id,
        claimText: recipeUserClaim.userClaim.name
      },
      { withCredentials: true }
    );
  }
};
